var pl = {
  "Add Quantity Breaks to your product page": "Dodaj rabaty ilościowe do strony produktu",
  "Add Upsell.com to your ": "Dodaj Upsell.com do swojej ",
  "All time": "Cały czas",
  "and select": "i wybierz",
  "button": "przycisk",
  "Cart drawer page": "Strona szuflady koszyka",
  "Cart page": "Strona koszyka",
  "Check status": "Sprawdź status",
  "Checkout page": "Strona kasy",
  "Click": "Kliknij",
  "Click on": "Kliknij na",
  "Click the": "Kliknij",
  "Custom slot": "Niestandardowy slot",
  "Custom slots": "Niestandardowe sloty",
  "Custom Slots": "Niestandardowe sloty",
  "contact support.": "skontaktuj się z pomocą techniczną.",
  "from the right sidebar": "z prawego paska bocznego",
  "Go to App Embeds": "Przejdź do integracji aplikacji",
  "Go to your Cart drawer page": "Przejdź do strony szuflady koszyka",
  "Go to your Cart page": "Przejdź do strony koszyka",
  "Go to your Checkout page": "Przejdź do strony kasy",
  "Go to your Order status page": "Przejdź do strony statusu zamówienia",
  "Go to your Post purchase page": "Przejdź do strony po zakupie",
  "Go to your Product page": "Przejdź do strony produktu",
  "Go to your Thank you page": "Przejdź do strony z podziękowaniami",
  "items": "przedmioty",
  "in the left sidebar": "w lewym pasku bocznym",
  "Last 12 months": "Ostatnie 12 miesięcy",
  "Last 30 days": "Ostatnie 30 dni",
  "Last 365 days": "Ostatnie 365 dni",
  "Last 7 days": "Ostatnie 7 dni",
  "Last 90 days": "Ostatnie 90 dni",
  "Last month": "Ostatni miesiąc",
  "Last year": "Zeszły rok",
  "Make sure": "Upewnij się, że",
  "Need assistance? Contact our support team for help.": "Potrzebujesz pomocy? Skontaktuj się z naszym zespołem wsparcia.",
  "Order status page": "Strona statusu zamówienia",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Nasza aplikacja przechodzi obecnie małą magię, aby ulepszyć Twoje doświadczenia.",
  "Post purchase page": "Strona po zakupie",
  "Product page": "Strona produktu",
  "Save": "Zapisz",
  "Scroll to the bottom and select": "Przewiń na dół i wybierz",
  "Select": "Wybierz",
  "Success. Please continue.": "Sukces. Proszę kontynuować.",
  "Thank you page": "Strona z podziękowaniami",
  "The Upsell.com team.": "Zespół Upsell.com.",
  "The Upsell.com widget is not placed on ": "Widżet Upsell.com nie jest umieszczony na ",
  ". Please follow the steps above or ": ". Postępuj zgodnie z powyższymi krokami lub ",
  "Today": "Dzisiaj",
  "toggle is on": "przełącznik jest włączony",
  "Total": "Razem",
  "under": "pod",
  "We apologize for any inconvenience caused,": "Przepraszamy za wszelkie niedogodności,",
  "We apologize for any inconvenience caused.": "Przepraszamy za wszelkie niedogodności.",
  "We'll be done in a few minutes!": "Skończymy za kilka minut!",
  "We're improving our services!": "Ulepszamy nasze usługi!",
  "Widget already added": "Widżet już dodany",
  "Yesterday": "Wczoraj",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Włączyłeś widżet w swoim sklepie online, ale nie zapisałeś go w edytorze Upsell",
  "You placed the widget on the ": "Umieściłeś widżet na ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", ale nie zapisałeś go w edytorze Shopify. Wróć do ",
  " and save the changes.": " i zapisz zmiany."
};

export { pl as default };
//# sourceMappingURL=pl.json.js.map
